<template>
  <div class="container-fluid">
    <div class="page-title">
      <i class="fa-regular fa-map"></i>
      <h1>{{ $t("COMMON.LOCATIONS") }}</h1>
    </div>
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">{{ $t("LOCATIONS.LOCATIONS_LIST") }}</h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openLocationCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_LOCATIONS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">{{
                $t("LOCATIONS.ADD_LOCATION")
              }}</span>
            </base-button>
            <!--<notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_LOCATIONS)"
              :objectType="'locations'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />-->
          </div>
        </div>
      </div>

      <location-list-table
        @onViewLocation="openLocationViewModal"
        @onEditLocation="openLocationEditModal"
        @onDeleteLocation="deleteLocation"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewLocationModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewLocationModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'LOCATION'"
          @onCloseModal="closeLocationModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("LOCATIONS.VIEW_LOCATION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openLocation"
                :objectType="'locations'"
                :objectId="openLocation.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="edit"
                  @click="openLocationEditModal(openLocation)"
                >
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <button class="delete" @click="deleteLocation(openLocation)">
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeLocationModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-location-page
              v-if="openLocation"
              :locationId="openLocation.id"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditLocationModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditLocationModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'LOCATION'"
          @onCloseModal="closeLocationModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("LOCATIONS.EDIT_LOCATION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="view"
                  @click="openLocationViewModal(openLocation)"
                >
                  <i class="fal fa-expand-alt"></i>
                  <span>{{ $t("COMMON.VIEW") }}</span>
                </button>
              </base-dropdown>
              <button
                class="close"
                @click="openLocationViewModal(openLocation)"
              >
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-location-page
              v-if="openLocation"
              :locationId="openLocation.id"
              @onViewLocation="openLocationViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddLocationModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddLocationModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'LOCATION'"
          @onCloseModal="closeLocationModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("LOCATIONS.ADD_LOCATION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="closeLocationModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-location-page @onViewLocation="openLocationViewModal" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import LocationListTable from "./partials/LocationListTable.vue";
import EditLocationPage from "./components/EditLocationComponent.vue";
import AddLocationPage from "./components/AddLocationComponent.vue";
import ViewLocationPage from "./components/ViewLocationComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    LocationListTable,
    NotificationSubscription,
    EditLocationPage,
    AddLocationPage,
    ViewLocationPage,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const locationId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewLocationModalOpened = false;
    let isEditLocationModalOpened = false;
    let isAddLocationModalOpened = false;
    let openLocation = null;
    if (locationId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewLocationModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditLocationModalOpened = true;
      }
      openLocation = { id: locationId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddLocationModalOpened = true;
    }
    return {
      isViewLocationModalOpened: isViewLocationModalOpened,
      isEditLocationModalOpened: isEditLocationModalOpened,
      isAddLocationModalOpened: isAddLocationModalOpened,
      openLocation: openLocation,
      renderKey: 1,
    };
  },

  methods: {
    openLocationCreateModal() {
      this.closeLocationModal();
      this.isAddLocationModalOpened = true;

      this.$router.replace({
        name: "List Locations",
        query: { action: QUERY_ACTIONS_ADD },
      });
    },
    openLocationViewModal(location, reRender = false) {
      this.closeLocationModal();
      this.openLocation = location;
      this.isViewLocationModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      this.$router.replace({
        name: "List Locations",
        query: { id: this.openLocation.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    openLocationEditModal(location) {
      this.closeLocationModal();
      this.openLocation = location;
      this.isEditLocationModalOpened = true;

      this.$router.replace({
        name: "List Locations",
        query: { id: this.openLocation.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    closeLocationModal(goBack = false, grid = false) {
      if (goBack && this.$store.getters["routes/previousPathRoute"]) {
        if (grid) {
          this.$store.dispatch("routes/goBackToPreviousGrid");
        } else {
          this.$store.dispatch("routes/goToPreviousPath");
        }
        return;
      }
      this.isAddLocationModalOpened = false;
      this.isViewLocationModalOpened = false;
      this.isEditLocationModalOpened = false;
      this.openLocation = null;

      // if (
      //   this.$route.name !== "List Locations" ||
      //   JSON.stringify(this.$route.query) !== JSON.stringify({})
      // ) {
      //   this.$router
      //     .replace({
      //       name: "List Locations",
      //       query: {},
      //     })
      //     .catch((err) => {
      //       if (err.name !== "NavigationDuplicated") {
      //         throw err;
      //       }
      //     });
      // }
    },

    async deleteLocation(location) {
      const confirmation = await swal.fire({
        title: this.$t("LOCATIONS.DELETE_THIS_LOCATION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch("locations/destroy", location.id);
          this.renderKey++;
          this.closeLocationModal();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("LOCATIONS.LOCATION_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
